import { getApiUrl } from '../config/appConfig';

export type ProductoFoto = {
  id: number;
  codigoArticulo: string;
  esPrincipal: boolean;
  orden: number;
  fechaCreacion?: string;
  thumbnailUrl: string;
  mediumUrl: string;
  fullUrl: string;
  contentType?: string;
  nombreArchivoOriginal?: string | null;
};

type ProductoConFotos = {
  codigoArticulo?: string | null;
  codigo?: string | null;
  imagen?: string | null;
  imagenUrl?: string | null;
  urlImagen?: string | null;
  imageUrl?: string | null;
  foto?: string | null;
  fotos?: ProductoFoto[] | null;
};

const FALLBACK_IMAGE = '/assets/sin_foto.png';

const buildLegacyImageUrl = (codigo?: string | null) =>
  codigo ? `${getApiUrl()}/api/productos/${codigo}/imagen` : null;

export const getProductoPrimaryPhoto = (producto: ProductoConFotos | null | undefined): ProductoFoto | null => {
  if (!producto?.fotos?.length) {
    return null;
  }

  return producto.fotos.find((foto) => foto.esPrincipal) ?? producto.fotos[0] ?? null;
};

export const getProductoImageBySize = (
  producto: ProductoConFotos | null | undefined,
  size: 'thumbnail' | 'medium' | 'full',
): string => {
  const fotoPrincipal = getProductoPrimaryPhoto(producto);
  if (fotoPrincipal) {
    if (size === 'thumbnail') return fotoPrincipal.thumbnailUrl;
    if (size === 'full') return fotoPrincipal.fullUrl;
    return fotoPrincipal.mediumUrl;
  }

  const legacyField = producto?.imagenUrl || producto?.urlImagen || producto?.imageUrl || producto?.foto || producto?.imagen || null;
  const codigo = producto?.codigoArticulo || producto?.codigo || null;
  return legacyField || buildLegacyImageUrl(codigo) || FALLBACK_IMAGE;
};

export const getProductoFallbackImage = () => FALLBACK_IMAGE;
